import { combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import LanguageReducer from '../reducers/Language/slice';
import ModalStateReducer from '../reducers/ModalsState/slice';
import SettingsReducer from '../reducers/Settings/slice';
import AppReducer from './App/appSlice';
import AuthReducer from './Auth/authSlice';
import ChangePasswordReducer from './ChangePassword/changePasswordSlice';
import ChatReducer from './Chat/slice';
import IFrameReducer from './IFrame/iFrameSlice';
import NotificationsReducer from './Notifications/slice';
import PasswordRecoveryReducer from './PasswordRecovery/passwordRecoverySlice';
import ResultsReducer from './Results/resultsSlice';
import SignupReducer from './SignUp/signupSlice';
import StableReducer from './Stable/slice';
import StableTabReducer from './Stable/tabs';
import WalletReducer from './Wallet/slice';
import UpcomingRacesReducer from './Race/raceSlice';
import SocialReducer from './Social/slice';
import JockeysReducer from './Stable/jockeys';
import SkinsReducer from './Stable/skins';
import ConfiguratorReducer from './Stable/configurator';
import GuildReducer from './Guild/slice';
import RaceReducer from './Guild/race';
const rootReducer = combineReducers({
    settings: SettingsReducer,
    language: LanguageReducer,
    modal: ModalStateReducer,
    auth: AuthReducer,
    signup: SignupReducer,
    changePassword: ChangePasswordReducer,
    passwordRecovery: PasswordRecoveryReducer,
    app: AppReducer,
    notifications: NotificationsReducer,
    chat: ChatReducer,
    stable: StableReducer,
    iframe: IFrameReducer,
    stableTab: StableTabReducer,
    jockeys: JockeysReducer,
    skins: SkinsReducer,
    configurator: ConfiguratorReducer,
    wallet: WalletReducer,
    social: SocialReducer,
    guild: GuildReducer,
    race: RaceReducer,
    upcomingRaces: UpcomingRacesReducer,
    results: ResultsReducer
});
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
export default rootReducer;
